/**
 * ApiError — 业务侧捕获的请求错误。
 *
 * 设计要点：
 *  - code 字段永远存在；http 字段为 0 表示网络层异常（fetch 抛错），
 *    其余取真实 HTTP 状态码。
 *  - message 是给人看的简短描述（不参与 telemetry 序列化）。
 *  - 与旧 client.ts 的 ApiError 行为完全兼容：业务侧 `e instanceof ApiError`、
 *    `e.code`、`e.http` 三个属性都保持不变。
 */

export class ApiError extends Error {
  public readonly code: string;
  public readonly http: number;

  constructor(code: string, http: number, message: string) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    this.http = http;
  }
}
